export default "__VITE_ASSET__CnSMVHhJ__"